export enum AMPLITUDE_EVENTS {
  acceptOfferClicked = 'Accept offer clicked',
  acceptRightNowClicked = 'Accept right now clicked',
  accountMenuClicked = 'Account menu clicked',
  applicationRefreshed = 'Application refreshed',
  applicationTradingHistoryAndOffersPending = 'Application trading history and offers pending',
  backCTAClicked = 'Back CTA clicked',
  calculatorFilterChanged = 'Calculator filter changed',
  calculateOverpaymentClicked = 'Calculate overpayment clicked',
  columnReorder = 'Column reorder',
  columnToggle = 'Column toggle',
  commissionFeeClicked = 'Commission fee clicked',
  companySearchSelected = 'Company search selected',
  companyInputToggleClicked = 'Company input toggle clicked',
  contactLinkClicked = 'Contact link clicked',
  copyOfferClicked = 'Copy offer clicked',
  copyCompanyNameClicked = 'Copy company name clicked',
  copyRequirementsListClicked = 'Copy requirements list clicked',
  CTAClicked = 'CTA clicked',
  dashboardCTAClicked = 'Dashboard CTA clicked',
  dashboardRowClicked = 'Dashboard row clicked',
  directorSelected = 'Director selected',
  dobUpdated = 'DOB updated',
  documentRequirementsLoaded = 'Documents requirements loaded',
  documentUploadClicked = 'Document upload clicked',
  documentUploaded = 'Document uploaded',
  earlyRepaymentCalculatorDateChanged = 'Early repayment calculator date change',
  earlyRepaymentScheduleOpened = 'Early repayment schedule opened',
  emailRequirementsListClicked = 'Email requirements list clicked',
  checksRequiredShown = 'Checks required shown',
  exportCsvButtonClicked = 'Export CSV button clicked',
  externalLinkClicked = 'External link clicked',
  extraDetailsAdded = 'Extra details added',
  extraDetailsRemoved = 'Extra details removed',
  generateLinkOpenBankingEmailClicked = 'Generate link Open Banking email clicked',
  faqCategorySelected = 'FAQ category selected',
  faqQuestionSelected = 'FAQ question selected',
  initialApplicationCheckErrored = 'Initial application check errored',
  initialApplicationCheckSubmitted = 'Initial application check submitted',
  internalLinkClicked = 'Internal link clicked',
  introducerPortalVisited = 'Introducer portal visited',
  introducerRegisterSubmitted = 'Introducer registration submitted',
  latestSignupStepAccessed = 'Latest signup step accessed',
  loanPurposeSelected = 'Loan purpose selected',
  loggedOut = 'Logged out',
  manualAddressEntered = 'Manual address entered',
  modalOpened = 'Modal opened',
  monthFilterSelected = 'Month filter selected',
  navigationOpened = 'Navigation opened',
  newApplicationProductOffersPending = 'New application product offers pending',
  newApplicationSubmissionErrored = 'New application submission errored',
  newApplicationSubmitted = 'New application submitted',
  notificationsBellClicked = 'Notifications bell clicked',
  notificationsCTASelected = 'Notifications CTA clicked',
  notificationsFiltered = 'Notifications filtered',
  offerAgreed = 'Offer agreed',
  offerRejected = 'Offer rejected',
  offersErrored = 'Offers errored',
  openApplicationInNewTabClicked = 'Open application in new tab clicked',
  productTypeSelected = 'Product type selected',
  quickFilterClicked = 'Quick filter clicked',
  refreshRequirementsClicked = 'Refresh requirements clicked',
  rejectOfferClicked = 'Reject offer clicked',
  repaymentScheduleCSVExport = 'Repayment schedule CSV export',
  saveAndFinishLaterClicked = 'Save and finish later clicked',
  seeDetailsClicked = 'See details clicked',
  seeMoreNotificationsClicked = 'See more notifications clicked',
  showAllColumns = 'Show all columns',
  signupCTAClicked = 'Signup CTA clicked',
  submitDocumentsClicked = 'Submit documents clicked',
  tableFilterOpened = 'Table filter opened',
  tableFilterOptionApplied = 'Table filter option applied',
  tableFilterOptionCleared = 'Table filter option cleared',
  typescriptErrorCaught = 'TypeScript error caught',
}
